export enum ButtonV2Size {
  Small = 'small',
  Large = 'large',
}

export enum ButtonV2Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Line = 'line',
  Negative = 'negative',
  Static = 'static',
}
